module.exports = __webpack_public_path__ + "media/react/assets/AddUser-27e03ba0306abdec55ea44b47ed85e0e.svg";